import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=cf23b686&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerManagement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/customers/styles/customer-management-style.css?vue&type=style&index=0&id=cf23b686&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf23b686",
  null
  
)

/* custom blocks */
import block0 from "@/components/customers/locales/i18n-customer-management.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fcustomers%2FCustomerManagement.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports